module.exports = __webpack_public_path__ + "static/media/recommended.893f5548.svg";